import Vue from "vue";
import Cookie from './cookie'
import $ from 'jquery';
import QRCode from "qrcode";
// methods新增方法 exportTable

export const lockMaskScroll = (bodyCls => {
    let scrollTop
    return {
        afterOpen: function() {
            scrollTop = document.scrollingElement.scrollTop || document.body.scrollTop
            document.body.classList.add(bodyCls)
            document.body.style.top = -scrollTop + 'px'
        },
        beforeClose: function() {
            if (document.body.classList.contains(bodyCls)) {
                document.body.classList.remove(bodyCls)
                document.body.style = '';
                document.scrollingElement.scrollTop = scrollTop
            }
        }
    }
})('c-fixed')

/**
 * @param obj
 * @returns {string}
 */
export const queryParams = obj => {
    let qs = Object.keys(obj)
        .map(key => {
            let val = obj[key]
            if (val) {
                if (typeof val === 'object') {
                    val = JSON.stringify(val)
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val)
            }
        }).filter(Boolean)
        .join('&')

    return qs
}
/**
 * @param obj
 * @returns {string}
 */
export const goLogin = () => {
    window.location.href = '/logo?returnUrl='+encodeURIComponent(window.location.href);
}

export const scrollToDom = (dom) => {
    if (!dom) return false
    let top = dom.getBoundingClientRect().top + document.scrollingElement.scrollTop
    if (top > 0 && top < 1000) {
        document.scrollingElement.scrollTo(0, top)
    }
}

export const getQueryString = (name) => {
    var urlParams = window.location.search.substr(1).split('&');
    for (var i = 0; i < urlParams.length; i++) {
        if (name == urlParams[i].split('=')[0]) {
            // 返回当前参数的值 同时转码
            return decodeURI(urlParams[i].split('=')[1]);
        }
    }
}

//生成二维码
export const getQRCode = (val,callback) => {
  var opts = {
    errorCorrectionLevel: "H",
    type: "image/jpeg",
    rendererOpts: {
      quality: 0.3
    }
  };
  QRCode.toDataURL(val, opts, (err, url) => {
    if (err) throw err;
    callback && callback(url)
  });
}

export const copyUrl = (content, that) => {
  /**
   * 复制内容到粘贴板
   * content : 需要复制的内容
   * message : 复制完后的提示，不传则默认提示"复制成功"
   */
  const aux = document.createElement("input");
  aux.setAttribute("value", content);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  document.body.removeChild(aux);
  that.$message.success("复制成功");
}


export const form_bak = {
  id: null,
  tenantId: null,
  title: "",
  viceTitle: "",
  titlePicUrl: "",
  summary: "", // 摘要
  content: "", // 正文
  sensitiveWords: "", // 敏感词
  articleType: 1, //
  articleStatus: 1,
  userAgent: 1,
  articleSource: 1,
  diseaseLabels: [], // 疾病标签
  contentSymptoms: [], // 症状标签
  // 查重----------------------------
  isArticleOriginaly: false,
  articleOriginality: "",
  articleOriginalityText: '',
  originalityCheckTime: '',
  articleOriginalityCode: '',
  // 查重----------------------------
  originalAuthor: {
    articleId: undefined,
    created: undefined,
    fullOriginalAuthorHeadPic: "",
    id: undefined,
    modified: undefined,
    originalAuthorDepart: "",
    originalAuthorHeadPic: "",
    originalAuthorId: "", // 必须传
    originalAuthorName: "",
    originalAuthorPin: "", // 必须传
    originalAuthorTitle: "",
    originalAuthorType: "", // 必须传
    originalAuthorUnit: "",
    yn: undefined
  },
  articleLevel: "",
  reprintedFrom: "",
  originalPublishTime:"",
  tenantAppId: "",
  tenantUnid: "",
  contentBusinesses: [], // 关联业务
  contentCategorys: [], // 关联栏目、频道
  contentChannels: [], // 频道
  extensionContentLabels: [],
  contentLabels:[],
  contentIndexes: [], //索引
};

/**
 * 节流
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @return null
 */
let timer, flag;
export function throttle(func, wait = 1000, arg) {
  if (!flag) {
    flag = true;
    // 如果是立即执行，则在wait毫秒内开始时执行
    typeof func === 'function' && func(arg);
    timer = setTimeout(() => {
      flag = false;
    }, wait);
  }
}
